module.exports = __webpack_public_path__ + "a83c1f5a76eb44d2d43eb1cd915e9fcb.pdf";